module.exports = __webpack_public_path__ + "static/media/IDEA Group.297d66b3.png";